import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9bac4d6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "contact",
  class: "section contact"
}
const _hoisted_2 = { class: "contact__intro" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "contact__eyebrow" }, "Nächster Schritt", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Wenn es um Softwarearchitektur, technische Leitung oder Vecura geht, lass uns sprechen. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "contact__intro-copy" }, " Für konkrete Anfragen erreichst du mich direkt per E-Mail. LinkedIn eignet sich für beruflichen Kontext und Austausch. Alles rund um Vecura läuft über die Vecura-Website oder die Unternehmensmail. ", -1))
const _hoisted_6 = { class: "contact__signature" }
const _hoisted_7 = { class: "contact__portrait" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Timo Rothdeutsch"),
  /*#__PURE__*/_createElementVNode("span", null, "Mitgründer & COO bei Vecura"),
  /*#__PURE__*/_createElementVNode("small", null, " Softwarearchitektur, KI/RAG, Anforderungsanalyse und technische Führung zwischen Fachlichkeit, Produkt und Engineering. ")
], -1))
const _hoisted_10 = { class: "contact__body" }
const _hoisted_11 = ["href", "target", "rel", "aria-label"]
const _hoisted_12 = {
  class: "contact__label",
  "aria-hidden": "true"
}

import ContactChannelIcon from "@/components/icons/ContactChannelIcon.vue";
import ExternalLinkIcon from "@/components/icons/ExternalLinkIcon.vue";
import contactPortrait from "@/assets/timo-contact-portrait.jpg";
import { contactChannels } from "@/data/profile";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactSection',
  setup(__props) {

function isExternalLink(href: string): boolean {
  return href.startsWith("http");
}

function getChannelIcon(label: string): "mail" | "linkedin" | "vecura" {
  const normalizedLabel = label.toLowerCase();

  if (normalizedLabel.includes("mail")) {
    return "mail";
  }

  if (normalizedLabel.includes("linkedin")) {
    return "linkedin";
  }

  return "vecura";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("figure", _hoisted_7, [
          _createElementVNode("img", {
            src: _unref(contactPortrait),
            alt: "Portrait von Timo Rothdeutsch",
            loading: "lazy",
            decoding: "async"
          }, null, 8, _hoisted_8)
        ]),
        _hoisted_9
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactChannels), (channel) => {
        return (_openBlock(), _createElementBlock("a", {
          key: channel.href,
          class: "contact__channel",
          href: channel.href,
          target: isExternalLink(channel.href) ? '_blank' : undefined,
          rel: isExternalLink(channel.href) ? 'noopener noreferrer' : undefined,
          "aria-label": `${channel.label}: ${channel.value}`
        }, [
          _createElementVNode("span", _hoisted_12, [
            _createVNode(ContactChannelIcon, {
              class: "contact__brand-icon",
              type: getChannelIcon(channel.label)
            }, null, 8, ["type"])
          ]),
          _createElementVNode("strong", null, _toDisplayString(channel.value), 1),
          _createElementVNode("em", null, _toDisplayString(channel.note), 1),
          _createVNode(ExternalLinkIcon, { class: "contact__target-icon" })
        ], 8, _hoisted_11))
      }), 128))
    ])
  ]))
}
}

})